import { render, staticRenderFns } from "./DictionaryFaculties.vue?vue&type=template&id=33084a0e&scoped=true&"
import script from "./DictionaryFaculties.vue?vue&type=script&lang=js&"
export * from "./DictionaryFaculties.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryFaculties.vue?vue&type=style&index=0&id=33084a0e&scoped=true&lang=scss&"
import style1 from "./DictionaryFaculties.vue?vue&type=style&index=1&id=33084a0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33084a0e",
  null
  
)

export default component.exports